// <template>
// 	<div class="platform-protocol">
// 		<hd title="证照信息"></hd>
// 		<div>
// 			<img alt="license_information" :src="oss_url + '/car_rental/license_information/license_information.jpg'"/>
// 		</div>
// 	</div>
// </template>
//
// <script>
import {oss_url,test} from './../../../dep/const.js'
module.exports = {
	data(){
		return{
			oss_url:oss_url
		}
	},
    components: {
        'hd': require('c/near_powerstation/header.vue')
    },
}
// </script>
//
// <style lang="sass" scoped>
// .platform-protocol{
//     width:100%;
//     min-height:100%;
//     padding:.32rem;
//     box-sizing:border-box;
//     background:#fff;
//     color: #252F3A;
// }
// </style>
//
//
/* generated by vue-loader */



// WEBPACK FOOTER //
// ./src/component/static_page/license_information.vue